import React from 'react';
import {inject, observer} from "mobx-react";
import {withRouter} from "react-router-dom";
import { MainTemplate, TestTemplate }  from "./templates";

export default
@inject( 'MainStore')
@withRouter
@observer
class MainContainer extends React.Component {
    render() {
        if (!this.props.MainStore.isTest) {
            return (
                <MainTemplate/>
            )
        }

        return (
            <TestTemplate/>
        )
    }
}
